import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('../views/Home.vue'),
        children: [
            {
                path: '',
                name: 'Home.index',
                component: () => import('../views/home/HomeIndex.vue')
            },
            {
                path: 'deals',
                component: () => import('../views/home/CategoryPartner.vue'),
                children: [
                    {
                        path: 'show/:id',
                        name: 'Home.category.show',
                        component: () => import('../views/home/categoryPartner/show.vue')
                    },
                    {
                        path: ':category',
                        name: 'Home.category.partner',
                        component: () => import('../views/home/categoryPartner/index.vue')
                    }, {
                        path: ':category/:subCategory',
                        name: 'Home.subcategory.partner',
                        component: () => import('../views/home/categoryPartner/index.vue')
                    }
                ]
            },
            {
                path: 'events',
                component: () => import('../views/home/Event.vue'),
                children: [
                    {
                        path: '',
                        name: 'home.event',
                        component: () => import('../views/home/Event/index.vue')
                    },
                    {
                        path: 'view/:id',
                        name: 'home.event.show',
                        component: () => import('../views/home/Event/show.vue')
                    }
                ]
            },
            {
              path: '',
              name: 'home.',
            },
            {
                path: 'contact',
                name: 'home.contact',
                component: () => import('../views/home/Contact.vue')
            },
            {
                path: 'register/plan',
                component: () => import('../views/home/paiement/Plan.vue'),
                name: 'Home.plan.choose',
            },
            {
                path: 'about',
                name: 'About',
                component: () => import('../views/home/About.vue')
            }
        ]
    },
    {
        path: '/register',
        component: () => import('../views/Security.vue'),
        children: [
            {
                path: '',
                name: 'register',
                component: () => import('../views/security/Register.vue')
            },
            {
                path: 'partner/:p',
                name: 'registerPartner',
                component: () => import('../views/security/RegisterPartner.vue'),
                children: [
                    {
                        path: ':g',
                        name: 'RegisterStep',
                        component: () => import('../views/security/step/Steps.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/login',
        component: () => import('../views/Security.vue'),
        children: [
            {
                path: '',
                name: 'login',
                component: () => import('../views/security/Login.vue')
            }]
    }
]

const router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    mode: 'history',
    linkExactActiveClass: 'active',
    base: process.env.BASE_URL,
    routes
})

export default router
